import * as Cesium from 'mars3d-cesium'

const LEGACY_TILE_CACHE_WORKER_PATH = '/platform-tile-cache-sw.js'
const LEGACY_TILE_CACHE_NAME_PREFIX = 'platform-map-tiles-'
const LEGACY_TILE_CACHE_RELOAD_KEY = 'platform-tile-cache-sw-removed'

let initialized = false

function isLegacyTileCacheWorker (worker?: ServiceWorker | null) {
  return Boolean(worker?.scriptURL?.includes(LEGACY_TILE_CACHE_WORKER_PATH))
}

async function removeLegacyTileCacheServiceWorker () {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return

  try {
    const registrations = await navigator.serviceWorker.getRegistrations()
    const legacyRegistrations = registrations.filter(registration => (
      isLegacyTileCacheWorker(registration.active) ||
      isLegacyTileCacheWorker(registration.waiting) ||
      isLegacyTileCacheWorker(registration.installing)
    ))
    const wasControlledByLegacyWorker = isLegacyTileCacheWorker(navigator.serviceWorker.controller)
    const unregisterResults = await Promise.all(
      legacyRegistrations.map(registration => registration.unregister())
    )

    if ('caches' in window) {
      const cacheNames = await window.caches.keys()
      await Promise.all(cacheNames
        .filter(name => name.startsWith(LEGACY_TILE_CACHE_NAME_PREFIX))
        .map(name => window.caches.delete(name)))
    }

    const removedLegacyWorker = unregisterResults.some(Boolean) || wasControlledByLegacyWorker
    if (removedLegacyWorker && sessionStorage.getItem(LEGACY_TILE_CACHE_RELOAD_KEY) !== 'true') {
      sessionStorage.setItem(LEGACY_TILE_CACHE_RELOAD_KEY, 'true')
      window.location.reload()
      return
    }
    sessionStorage.removeItem(LEGACY_TILE_CACHE_RELOAD_KEY)
  } catch (error) {
    console.warn('清理旧地图瓦片缓存失败:', error)
  }
}

export function initializeTileRequestOptimizer () {
  if (initialized) return
  initialized = true

  // Cesium still schedules requests; these values allow several tile hosts to
  // progress concurrently without letting one host monopolize the connection.
  Cesium.RequestScheduler.maximumRequests = 64
  Cesium.RequestScheduler.maximumRequestsPerServer = 12

  void removeLegacyTileCacheServiceWorker()
}
